import { ApiRequest } from '../../api/request';
import { LoginResponse } from '../../auth/loginResponse';

export class LoginService extends ApiRequest {
  constructor($http, $q, appConfig, userService) {
    'ngInject';
    super({ $http, $q, appConfig, userService });
  }

  login(credentials) {
    return this.requestLogin('POST', 'login', credentials);
  }

  customerEntryLogin() {
    return this.requestLogin('GET', 'guest');
  }

  requestLogin(method, path, data) {
    const { $q, $http, userService } = this;
    this.loginCanceller = $q.defer();

    $http({
      method: method,
      data,
      url: `${this.api}/auth/${path}`,
      timeout: this.loginCanceller.promise,
    })
      .then(LoginResponse.loginTo(userService))
      .then(this.loginCanceller.resolve)
      .catch(this.loginCanceller.reject);

    return this.loginCanceller.promise;
  }

  /**
   * { hostedLogin: true } when the login page is rendered by Keycloak (backend env KWH_HOSTED_LOGIN)
   */
  loginOptions() {
    return this.$http({
      method: 'GET',
      url: `${this.api}/auth/login-options`,
      error: {
        silent: true,
      },
    }).then(({ data }) => data || {});
  }

  /**
   * ends the Keycloak session of the hosted login, otherwise the next /login would log in again silently
   */
  logout() {
    return this.$http({
      method: 'POST',
      url: `${this.api}/auth/logout`,
      error: {
        silent: true,
      },
    });
  }

  loginAbort() {
    if (this.loginCanceller) {
      this.loginCanceller.resolve();
    }
  }

  resetPassword(credentials, userRepeat) {
    return this.$http({
      method: 'POST',
      url: `${this.api}/auth/resetPassword`,
      data: {
        password: credentials.password,
        resetToken: credentials.resetToken,
        userName: userRepeat,
      },
      error: {
        silent: true,
      },
    });
  }

  sendPasswordResetMail(userName) {
    return this.$http({
      method: 'POST',
      data: {
        userName,
      },
      url: `${this.api}/auth/sendPasswordResetMail`,
    });
  }

  isProtected() {
    if (this.userService.isCustomerEntryUser()) {
      return this.$q.resolve(true);
    }
    return this.$q.resolve(false);
  }

  sendTwoFactorSms(data) {
    return this.$http({
      method: 'POST',
      url: `${this.api}/auth/customer/verify`,
      data,
      error: {
        silent: true,
      },
    });
  }

  validateSecret(data) {
    return this.$http({
      method: 'POST',
      url: `${this.api}/auth/customer/login`,
      data,
      error: {
        silent: true,
      },
    });
  }
}
